/* ─── Paleta compartida del módulo Presupuestos ──────────────────
   Fuente única de verdad para los colores de marca SURA usados en
   todas las vistas de conceptos y en el dashboard, para evitar tonos
   distintos del "mismo" color entre pantallas. */

export const SURA_BLUE    = '#003366'; // navy
export const SURA_BLUE2   = '#0062A5'; // azul medio
export const SURA_TEAL    = '#0891B2'; // teal / cian
export const SURA_GREEN   = '#107C41'; // verde oscuro
export const SURA_GOLD    = '#C9A227'; // dorado (texto/íconos sobre fondo claro)
export const SURA_GOLD_BG = '#FFD100'; // dorado pleno (acentos, barras)
export const SURA_SLATE   = '#5B6B7A'; // gris azulado (neutro)

// Paleta de series para gráficas multi-concepto: 12 tonos bien diferenciados
// dentro de la familia azul / teal / verde / dorado de la marca (sin morados
// ni colores ajenos a la estética del sitio).
export const SERIES_PALETTE = [
  '#003366', // navy
  '#00A859', // verde brillante
  '#0062A5', // azul medio
  '#FFD100', // dorado SURA
  '#0891B2', // teal
  '#5B9BD5', // azul claro
  '#107C41', // verde oscuro
  '#5B6B7A', // gris azulado
  '#00C2D1', // cian brillante
  '#8FBF6B', // verde oliva claro
  '#1A9070', // verde-teal
  '#89A9C9', // azul acero pálido
];

export const getSeriesColor = (index) => SERIES_PALETTE[index % SERIES_PALETTE.length];

export const MESES_ORDEN = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
  'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'];

// Meses que deben salir en una gráfica anual: para el año en curso, solo hasta
// el mes actual (no se muestran meses futuros que aún no han llegado). Para
// años pasados se muestran los 12; para años futuros, ninguno.
export function mesesVisibles(anio) {
  const now = new Date();
  const anioActual = now.getFullYear();
  if (anio < anioActual) return MESES_ORDEN;
  if (anio > anioActual) return [];
  return MESES_ORDEN.slice(0, now.getMonth() + 1);
}

// Serie anual de UN dato específico (una línea, un enlace, un equipo...): toma
// su arreglo de gastos y devuelve solo los meses que tienen dato y que ya
// pasaron. Si el dato solo existió en un mes, sale solo ese mes.
export function serieAnualItem(gastos, anio, campoMonto = 'monto_dolar') {
  const visibles = mesesVisibles(anio);
  return MESES_ORDEN
    .filter(mes => visibles.includes(mes))
    .map(mes => {
      const g = (gastos || []).find(x => x.mes === mes && x.anio === anio);
      if (!g) return null;
      return { name: mes.substring(0, 3), fullMonth: mes, total: Number(g[campoMonto] || 0) };
    })
    .filter(Boolean);
}

// Aclara (percent > 0) u oscurece (percent < 0) un color hex, para generar
// variantes de un mismo tono de marca (ej. diferenciar dos conceptos del
// mismo tipo manteniendo el color "familia" reconocible).
export const shadeColor = (hex, percent) => {
  const num = parseInt(hex.replace('#', ''), 16);
  const clamp = (v) => Math.max(0, Math.min(255, v));
  const r = clamp((num >> 16) + Math.round(2.55 * percent));
  const g = clamp(((num >> 8) & 0x00ff) + Math.round(2.55 * percent));
  const b = clamp((num & 0x0000ff) + Math.round(2.55 * percent));
  return `#${(0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1)}`;
};
